module.exports = __webpack_public_path__ + "static/media/img126_R.d6e1df70.jpg";